<script setup>
import { TabsRoot, useForwardPropsEmits } from "reka-ui";
import { cn } from "@/shared/lib/utils";

const props = defineProps({
  defaultValue: { type: String, default: undefined },
  modelValue: { type: String, default: undefined },
  orientation: { type: String, default: undefined },
  dir: { type: String, default: undefined },
  activationMode: { type: String, default: undefined },
  class: { type: String, default: undefined },
});

const emits = defineEmits(["update:modelValue"]);

const forwarded = useForwardPropsEmits(() => {
  const { ...rest } = props;

  return rest;
}, emits);
</script>

<template>
  <TabsRoot
    v-slot="slotProps"
    data-slot="tabs"
    v-bind="forwarded"
    :class="cn('flex flex-col gap-2', props.class)"
  >
    <slot v-bind="slotProps" />
  </TabsRoot>
</template>
